var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cl right-tab"},_vm._l((_vm.list),function(item,index){return _c('span',{staticClass:"z tab-item hand",class:_vm.$route.path === item.path ? 'on' : '',on:{"click":function($event){return _vm.$router.push({path:item.path})}}},[_vm._v(_vm._s(item.title))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }